import React from "react";
import { Link } from "react-router-dom";

import "./Legal.scss";

export function TermsOfService() {
  return (
    <div className="legal-component">
      <div className="legal-content">
        <h1>Terms &amp; Conditions</h1>
        <p className="legal-updated">Triple P Disposal LLC</p>

        <p>
          These Terms &amp; Conditions govern the text messaging program offered
          by Triple P Disposal LLC ("Triple P," "we," "us," or "our"). By opting
          in to receive text messages from Triple P, you agree to these terms.
        </p>

        <h2>Program Description</h2>
        <p>
          When you opt in, Triple P will send you recurring text messages related
          to your dumpster rental or trash removal order. These messages may
          include order confirmations, delivery and pickup scheduling updates,
          and other service notifications.
        </p>

        <h2>Message Frequency</h2>
        <p>
          Message frequency varies and depends on your order activity. You may
          receive messages when you place an order and as your delivery or pickup
          is scheduled and updated.
        </p>

        <h2>Cost</h2>
        <p>
          Message and data rates may apply. Triple P does not charge for the
          messages, but your mobile carrier's standard message and data rates
          will apply based on your plan.
        </p>

        <h2>HELP &amp; STOP Instructions</h2>
        <p>
          For help at any time, reply <strong>HELP</strong> to any message you
          receive from us. To stop receiving text messages, reply{" "}
          <strong>STOP</strong> to any message. After you send STOP, we will send
          you one confirmation message and will not send you any further text
          messages unless you opt in again.
        </p>

        <h2>Carriers</h2>
        <p>
          Carriers are not liable for delayed or undelivered messages. Message
          delivery is subject to effective transmission by your mobile carrier
          and is not guaranteed.
        </p>

        <h2>Privacy</h2>
        <p>
          Your privacy is important to us. We do not sell, rent, or share your
          mobile phone number or SMS consent with third parties for marketing
          purposes. See our{" "}
          <Link to="/privacy">Privacy Policy</Link> for details.
        </p>

        <h2>Changes to These Terms</h2>
        <p>
          We may update these Terms &amp; Conditions from time to time. Continued
          participation in the text messaging program after changes take effect
          constitutes acceptance of the updated terms.
        </p>
      </div>
    </div>
  );
}
